export const API_HOST = process.env.REACT_APP_API_SERVER;

// AUTH
export const LOGIN_CHECK_URL = `${API_HOST}/security/check_login`;
export const REQUEST_PASSWORD_URL = `${API_HOST}/security/password/reset`;
export const LOGIN_URL = `${API_HOST}/security/login`;
export const LOGOUT_URL = `${API_HOST}/security/logout`;
export const REFRESH_TOKEN_URL = `${API_HOST}/security/token/refresh`;

// SESSION
export const ME_URL = `${API_HOST}/api/user`;

// COMMANDS
export const USER_COMMANDS_COUNTER_URL = `${API_HOST}/api/commands/user/counters`;

// SETTINGS
export const TIMEZONES_LIST = `${API_HOST}/api/settings/timezones`;

// USER
export const GET_USER = `${API_HOST}/api/user/`;
export const GET_USER_EVENTS = `${API_HOST}/api/user/events`;

// COMPANIES
export const GET_COMPANY = `${API_HOST}/api/company/`;

// OFFICES
export const GET_OFIICE = `${API_HOST}/api/office/`;

// OWNERS
export const SEARCH_OWNERS = `${API_HOST}/api/owners/search`;
